import { createAsyncThunk } from '@reduxjs/toolkit'
import { backend } from 'src/config'
import axiosInstance from 'src/utils/axios'

export const fetchClient = createAsyncThunk(
  'FETCH_CLIENT',
  async ({ clientId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${backend}/api/client/${clientId}`
      )
      return response.data
    } catch (error) {
      console.error('Error in FETCH_CLIENT', error)
      return rejectWithValue([], error)
    }
  }
)

export const fetchManager = createAsyncThunk(
  'FETCH_MANAGER',
  async ({ userId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${backend}/api/staff/${userId}`)
      return response.data
    } catch (error) {
      console.error('Error in FETCH_MANAGER', error)
      return rejectWithValue([], error)
    }
  }
)

export const fetchCurrencyRate = createAsyncThunk(
  'FETCH_CURRENCY_RATE',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`${backend}/api/currency-rate`)
      return data.data
    } catch (error) {
      console.error('Error in FETCH_CURRENCY_RATE:', error)
      return rejectWithValue(
        error.response?.data || 'Failed to fetch currency rate'
      )
    }
  }
)

export const updateStaff2FA = createAsyncThunk(
  'UPDATE_STAFF_2FA',
  async ({ staffId, is2FAEnabled }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/staff/${staffId}/2fa?is2FAEnabled=${is2FAEnabled}`
      )
      return response.data
    } catch (error) {
      console.error('Error in UPDATE_STAFF_2FA', error)
      return rejectWithValue(error.response?.data || 'Failed to update 2FA')
    }
  }
)

export const updateClientVip = createAsyncThunk(
  'UPDATE_CLIENT_VIP',
  async ({ clientId, isVip }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/client/set-vip/${clientId}`,
        { isVip }
      )
      return response.data
    } catch (error) {
      console.error('Error in UPDATE_CLIENT_VIP', error)
      return rejectWithValue(
        error.response?.data || 'Failed to update VIP status'
      )
    }
  }
)

export const fetchStaffById = createAsyncThunk(
  'FETCH_STAFF_BY_ID',
  async ({ staffId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${backend}/api/staff/${staffId}?version=v2`
      )
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const fetchStores = createAsyncThunk(
  'FETCH_STORES',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${backend}/api/store`)
      return response.data.data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const fetchPvzList = createAsyncThunk(
  'FETCH_PVZ_LIST',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${backend}/api/pvz/data`)
      return response.data.content
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const createStaff = createAsyncThunk(
  'CREATE_STAFF',
  async (values, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${backend}/api/staff?version=v2`,
        values
      )
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const updateStaff = createAsyncThunk(
  'UPDATE_STAFF',
  async ({ staffId, values }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/staff/${staffId}?version=v2`,
        values
      )
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const assignUserToPvz = createAsyncThunk(
  'ASSIGN_USER_TO_PVZ',
  async ({ pvzId, userId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${backend}/api/pvz/data/${pvzId}/users/${userId}`
      )
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const removeUserFromPvz = createAsyncThunk(
  'REMOVE_USER_FROM_PVZ',
  async ({ pvzId, userId }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(
        `${backend}/api/pvz/data/${pvzId}/users/${userId}`
      )
      return { pvzId, userId }
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
